export const AUCTION_ACCESS_LOOKUP_STATE = {
	ENTRY: 'entry',
	LOADING: 'loading',
	SUCCESS: 'success',
	NOT_FOUND: 'not_found',
	ACCOUNT_EXISTS: 'account_exists',
	ERROR: 'error',
	UNAVAILABLE: 'unavailable',
};
